// Mirrors Finkit.Permissions.HostPagesPermissions.FinkitHostPagesPermissions.GlobalSymbols.
export const GlobalSymbolsPermissions = {
  view: 'HostPages.GlobalSymbols',
  create: 'HostPages.GlobalSymbols.Create',
  edit: 'HostPages.GlobalSymbols.Edit',
  approve: 'HostPages.GlobalSymbols.Approve',
  reject: 'HostPages.GlobalSymbols.Reject',
} as const;
